import { Phone } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A0A0A]">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
      <p className="text-outline font-display text-[13vw] font-extrabold leading-none tracking-tighter md:text-8xl">
        TRANSPORT OSÓB
      </p>

      <div className="mt-12 flex flex-col gap-8 border-t border-white/10 pt-10 md:flex-row md:items-center md:justify-between">
        <p data-testid="footer-tagline" className="max-w-sm text-sm leading-relaxed text-white/55">
          Przewóz osób – przejazdy lokalne i krajowe. Wesela, lotniska,
          wyjazdy służbowe, przewozy pracowników, dojazdy do lekarza
          i sanatoriów.
        </p>
        <a
          href="tel:+48737473050"
          data-testid="footer-phone-link"
          className="inline-flex w-fit items-center gap-3 rounded-full border border-white/15 px-7 py-4 font-display text-lg font-bold tracking-wide text-white transition-[border-color,color,transform] duration-200 hover:border-[#E2C792]/60 hover:text-[#E2C792] active:scale-95"
        >
          <Phone className="h-5 w-5" strokeWidth={2.2} />
          737 473 050
        </a>
      </div>

      <div className="mt-10 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-white/35 md:flex-row md:items-center md:justify-between">
        <p>© 2026 TRANSPORT OSÓB. Wszelkie prawa zastrzeżone.</p>
        <p>KOMFORT • BEZPIECZEŃSTWO • PUNKTUALNOŚĆ</p>
      </div>
    </div>
  </footer>
);
